import { Bell, Search, ChevronDown, Sun, Moon, Download } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Badge } from "../ui/badge";
import { useTheme } from "next-themes";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { useLocation } from "react-router-dom";
import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import {
  encryptData,
  retrieveData,
  storeData,
} from "../../LocalConnection/LocalConnection";
import { useCallback, useEffect, useState } from "react";
import {
  action_change_restaurant_token,
  get_all_restaurant_from_staff,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import {
  handleError,
  handleSuccessSession,
} from "../../CommonJquery/CommonJquery";

const POS_EXE_URL =
  "https://www.restaurantpanel.uprestro.com/UpRestro-Biller-Setup.exe";
const POS_EXE_NAME = "UpRestro-Biller-Setup.exe";

export function Header({ title, subtitle, filterType, onFilterChange }) {
  const pathname = useLocation();
  // console.log("Current Pathname:", pathname.pathname);
  const { theme, setTheme } = useTheme();
  let default_restaurant_id = retrieveData("default_restaurant_id");
  const [restuarnt, setrestuarnt] = useState([]);
  const [selectedOption, setselectedOption] = useState(default_restaurant_id);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    await server_post_data(get_all_restaurant_from_staff, fd, "")
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setrestuarnt(Response.data.message.restaurant_list);
          if (default_restaurant_id === "0" || default_restaurant_id === 0) {
            default_restaurant_id =
              Response.data.message.restaurant_list[0].primary_id;
          }

          let default_restaurant_id_dddd = retrieveData(
            "default_restaurant_id",
          );

          const selectedOptionsss = Response.data.message.restaurant_list.find(
            (opt) => opt.primary_id === parseInt(default_restaurant_id_dddd),
          );
          if (selectedOptionsss) {
            setselectedOption(selectedOptionsss.primary_id);
          }
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleChange1 = useCallback(async (default_restaurant_id) => {
    setshowLoaderAdmin(true);

    const fd = new FormData();
    fd.append("restaurant_id", default_restaurant_id);
    try {
      const response = await server_post_data(
        action_change_restaurant_token,
        fd,
      );

      if (response.data.error) {
        handleError(response.data.message);
      } else {
        let tokens = response.data.message.tokens || {};
        let data_restaurant = response.data.message.restaurant_data || {};
        storeData(
          "default_restaurant_id",
          encryptData(data_restaurant.primary_id),
        );
        storeData(
          "restaurant_name",
          encryptData(data_restaurant.restaurant_name),
        );
        storeData("packageName", encryptData(data_restaurant.database_name));
        storeData("access_token", tokens.access);
        storeData("refresh_token", tokens.refresh);

        handleSuccessSession("", "/dashboard");
      }
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  }, []);

  // blob download -> page kabhi navigate nahi hoga
  const handleDownloadExe = useCallback(
    async (e) => {
      if (e) e.preventDefault();
      if (downloading) return;

      setDownloading(true);
      setProgress(0);

      try {
        const response = await fetch(POS_EXE_URL, {
          cache: "no-store",
          mode: "cors",
        });

        if (!response.ok) {
          throw new Error("File not found");
        }

        const total = Number(response.headers.get("content-length")) || 0;
        const reader = response.body?.getReader();

        let blob;

        if (reader) {
          const chunks = [];
          let received = 0;

          while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            chunks.push(value);
            received += value.length;
            if (total) {
              setProgress(Math.round((received / total) * 100));
            }
          }

          blob = new Blob(chunks, { type: "application/octet-stream" });
        } else {
          blob = await response.blob();
        }

        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = POS_EXE_NAME;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 3000);
      } catch (error) {
        console.error("EXE download failed:", error);
        handleError("Download failed. Please try again.");
      } finally {
        setDownloading(false);
        setProgress(0);
      }
    },
    [downloading],
  );

  return (
    <header className="h-16 border-b border-border bg-background/80 backdrop-blur-sm sticky top-0 z-30">
      <div className="flex items-center justify-between h-full px-6">
        <div>
          <h1 className="text-xl font-bold text-foreground">{title}</h1>
          {subtitle && (
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          )}
        </div>

        <div className="flex items-center gap-4">
          <div className="space-y-2">
            <Select value={selectedOption} onValueChange={handleChange1}>
              <SelectTrigger className="h-9 text-sm">
                <SelectValue placeholder="Select Vendor" />
              </SelectTrigger>
              <SelectContent>
                {restuarnt.map((option, index) => (
                  <SelectItem key={index} value={option.primary_id}>
                    {option.restaurant_name +
                      "(" +
                      option.restaurant_city +
                      ")"}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {/* POS EXE Download */}
          <Button
            type="button"
            variant="outline"
            className="gap-2"
            onClick={handleDownloadExe}
            disabled={downloading}
            title="Download POS Desktop App"
          >
            <Download className="w-4 h-4" />
            <span className="text-sm hidden md:inline">
              {downloading
                ? progress
                  ? `${progress}%`
                  : "Downloading..."
                : "Download POS"}
            </span>
          </Button>

          {/* Search */}
          {/* <div className="relative hidden md:block">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input
              placeholder="Search..."
              className="w-64 pl-9 bg-muted/50 border-border/50 focus:bg-background"
            />
          </div> */}

          {/* Theme Toggle */}
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="relative"
          >
            <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
            <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
            <span className="sr-only">Toggle theme</span>
          </Button>

          {/* Notifications */}
          {/* <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="relative">
                <Bell className="w-5 h-5" />
                <Badge className="absolute -top-1 -right-1 h-5 w-5 p-0 flex items-center justify-center bg-destructive text-destructive-foreground text-xs">
                  3
                </Badge>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-80">
              <DropdownMenuLabel>Notifications</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem className="flex flex-col items-start gap-1 py-3">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-destructive" />
                  <span className="font-medium text-sm">
                    High Food Cost Alert
                  </span>
                </div>
                <p className="text-xs text-muted-foreground pl-4">
                  Raan-E-Sikandari cost exceeds 35% threshold
                </p>
              </DropdownMenuItem>
              <DropdownMenuItem className="flex flex-col items-start gap-1 py-3">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-warning" />
                  <span className="font-medium text-sm">
                    PO Pending Approval
                  </span>
                </div>
                <p className="text-xs text-muted-foreground pl-4">
                  3 purchase orders awaiting your approval
                </p>
              </DropdownMenuItem>
              <DropdownMenuItem className="flex flex-col items-start gap-1 py-3">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-primary" />
                  <span className="font-medium text-sm">GRN Received</span>
                </div>
                <p className="text-xs text-muted-foreground pl-4">
                  Grocery delivery from Reliance Fresh Wholesale
                </p>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu> */}

          {/* Date/Time Selector */}
          {/* Date/Time Selector */}
          {pathname.pathname === "/Dashboard" && (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="gap-2">
                  <span className="text-sm capitalize">
                    {filterType ? filterType.replaceAll("_", " ") : "All"}
                  </span>
                  <ChevronDown className="w-4 h-4" />
                </Button>
              </DropdownMenuTrigger>

              <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={() => onFilterChange("today")}>
                  Today
                </DropdownMenuItem>

                <DropdownMenuItem onClick={() => onFilterChange("yesterday")}>
                  Yesterday
                </DropdownMenuItem>

                <DropdownMenuItem onClick={() => onFilterChange("last_7_days")}>
                  Last 7 Days
                </DropdownMenuItem>

                <DropdownMenuItem
                  onClick={() => onFilterChange("last_30_days")}
                >
                  Last 30 Days
                </DropdownMenuItem>

                <DropdownMenuItem onClick={() => onFilterChange("this_month")}>
                  This Month
                </DropdownMenuItem>

                {/* <DropdownMenuSeparator /> */}

                {/* <DropdownMenuItem onClick={() => onFilterChange("custom")}>
                Custom Range
              </DropdownMenuItem> */}
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>
    </header>
  );
}